/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CancelCaseResponseJson } from './cancel-case-response-json';
import { CancelCaseResult } from '../results/cancel-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CancelCaseResponse extends ResponseWithErrorGeneric<CancelCaseResponseJson, CancelCaseResult> implements IResponseWithErrorGeneric<CancelCaseResult> {
  public failedClearanceCaseId: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<CancelCaseResponse>) {
    super(response, CancelCaseResult.Error);
    if (this.result === CancelCaseResult.InvalidStatus) {
      this.failedClearanceCaseId= this.body.failedClearanceCaseId;
    }
  }
  //</custom-body>
}
